<div class="footer">
    <ul class="nav list-inline col-xs-3" style="justify-content: center;">
        <li class="mx-2 my-2">
            <span>
                <a href="tel:+351939451440">
                    &copy; {{ currentYear }} Alfredo dos Frangos
                </a>
            </span>
        </li>
    </ul>
</div>
